// src/components/PrivateLayout.tsx

// 1. Remova a importação do Outlet. Em vez disso, importe ReactNode para tipar os 'children'.
import React, { useEffect, useRef, ReactNode } from 'react';
import { useAuth } from '@context/auth';

// 2. Defina a interface para as props, esperando 'children'
interface PrivateLayoutProps {
  children: ReactNode;
}

// 3. Receba { children } como argumento
const PrivateLayout: React.FC<PrivateLayoutProps> = ({ children }) => {
  const { signOut } = useAuth();
  const inactivityTimerRef = useRef<NodeJS.Timeout>();

  const INACTIVITY_TIMEOUT = 5 * 60 * 1000; // 5 minutos

  useEffect(() => {
    const logoutUser = () => {
      console.log('Usuário inativo, fazendo logout...');
      signOut();
    };

    const resetTimer = () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      inactivityTimerRef.current = setTimeout(logoutUser, INACTIVITY_TIMEOUT);
    };

    const events = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];
    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer();

    return () => {
      if (inactivityTimerRef.current) {
        clearTimeout(inactivityTimerRef.current);
      }
      events.forEach((event) => window.removeEventListener(event, resetTimer));
    };
  }, [signOut]);

  // 4. Renderize {children} em vez de <Outlet />
  // Usamos um Fragment <>...</> para não adicionar um nó extra no DOM.
  return <>{children}</>;
};

export default PrivateLayout;
